<div class="row">
  <div class="col-9">
    <div class="row">
      <div class="col-6">
        <div class="mb-4">
          <span class="fw-bold">Nom : </span>
          <span>{{ expert.lastName }}</span>
        </div>

        <div class="mb-4">
          <span class="fw-bold">Email : </span>
          <span>{{ expert.email }}</span>
        </div>
        <div class="mb-4">
          <span class="fw-bold">Expériences / parcours : </span>
          <div>{{ expert.experiences }}</div>
        </div>
      </div>
      <div class="col-6">
        <div class="mb-4">
          <span class="fw-bold">Prénom : </span>
          <span>{{ expert.firstName }}</span>
        </div>

        <div class="mb-4">
          <span class="fw-bold">Téléphone : </span>
          <span>{{ expert.phone }}</span>
        </div>
        <div class="mb-4 col-6">
          <span class="fw-bold">Fonction : </span>
          <div class="text-capitalize">{{ expert.roleLabel }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-3 p-2">
    <p-photo-miniature
      [imageUrl]="exportPhoto"
      class="mb-3"
    ></p-photo-miniature>
  </div>
  <!-- 
  <div *ngIf="exportPhoto" class="col-3 file-display position-relative">
    <img [src]="exportPhoto" alt="Photo" class="img-thumbnail" />
  </div> -->
</div>
